module.exports = __webpack_public_path__ + "static/ColoringPages.d31fa090.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/data/ColoringPages.pdf
// module id = 342
// module chunks = 35783957827783